import React, { Component } from "react";
import Card from "../components/Card";
import { ToastContainer, toast } from "react-toastify";
import { db } from "../config";
import moment from "moment";
import PostJobForm from "../components/PostJobForm";

class CreateJob extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      nigeriaStates: [],
      formData: {}
    };
    this.onChange = this.onChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleGetDate = this.handleGetDate.bind(this);
    this.editorChange = this.editorChange.bind(this);
  }

  onChange(name) {
    return e => {
      this.setState({
        formData: Object.assign({}, this.state.formData, {
          [name]: e.target.value
        })
      });
    };
  }

  editorChange(field) {
    return value => {
      console.log(value);
      this.setState({
        formData: Object.assign({}, this.state.formData, {
          [field]: value
        })
      });
    };
  }

  handleGetDate(date) {
    const newData = Object.assign({}, this.state.formData, {
      closingDate: moment(date).format("L")
    });
    this.setState({ formData: newData });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.setState({ loading: true });
    const { formData } = this.state;
    const jobId = this.props.match.params.id;

    // make sure we only use non empty fields
    let data = {};

    Object.keys(formData).forEach(key => {
      if (formData[key]) {
        data[key] = formData[key];
      }
    });

    db
      .collection("jobs")
      .where("id", "==", jobId)
      .get()
      .then(snap => {
        let id;
        snap.forEach(doc => (id = doc.id));
        return id;
      })
      .then(id => {
        db
          .collection("jobs")
          .doc(id)
          .update(data);
      })
      .then(() => {
        this.setState({ loading: false });
        setTimeout(() => this.props.history.push("/office"), 1500);
      })
      .catch(e => {
        this.setState({ loading: false });
        toast.error("An error ocuured!");
      });
  }

  render() {
    const { loading } = this.state;
    return (
      <div className="pt4 pb5 pa3">
        <ToastContainer position="top-center" />
        <h1 className="f3 fw5 tc mb3">Edit Job Details</h1>
        <Card
          style={{ maxWidth: 700, padding: "2rem" }}
          className="center bg-white"
        >
          <form onSubmit={this.handleSubmit}>
            <PostJobForm
              onChange={this.onChange}
              editorChange={this.editorChange}
              handleGetDate={this.handleGetDate}
            />
            <button
              type="submit"
              className={`button is-link is-medium mt4 ph4 ${loading &&
                "is-loading"}`}
            >
              Update
            </button>
          </form>
        </Card>
      </div>
    );
  }
}

export default CreateJob;



// WEBPACK FOOTER //
// ./src/pages/editJob.js